import React from 'react';
import { is } from '../../../services/classify';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Rows Item Component
 * @param narrow {boolean} Align same elements horizontaly
 * @param children {React.ReactNode}
 * - -------------------------- WEB PROPERTIES -------------------
 *  @param className {string} additionnal CSS Classes
 */
const RowItem = ({ className, narrow, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('row', narrow && is('narrow'), className));
    return React.createElement("div", { className: classes, ...others });
};
export default RowItem;
//# sourceMappingURL=RowItem.js.map